import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from './base-api.service';
import { Site, ApiResponse } from '@com.maessa.payroll.frontend/models';

@Injectable({ providedIn: 'root' })
export class SiteApiService extends BaseApiService {
  getSites(): Observable<ApiResponse<Site[]>> {
    return this.get<ApiResponse<Site[]>>(`${this.baseUrl}/sites`);
  }

  getSite(id: number): Observable<ApiResponse<Site>> {
    return this.get<ApiResponse<Site>>(`${this.baseUrl}/sites/${id}`);
  }
}
